import { Component, OnInit, Input, Injectable, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PatientDialogService } from 'src/app/services/Non-Master/PatientDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { formatDate, DatePipe } from '@angular/common';
import { Local } from 'protractor/built/driverProviders';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { BookingDialogService } from 'src/app/services/Non-Master/BookingDialog.service';
import { tPackageService } from 'src/app/services/tPackage.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { NewPatientDialogService } from 'src/app/services/Non-Master/NewPatientDialog.service';
import { tBookingService } from 'src/app/services/tBooking.service';
import { tBookingTimeModel } from 'src/app/models/tBookingModel';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { SearchItemIDDialogService } from 'src/app/services/Non-Master/SearchItemIDDialog.service';
import { tItemModel } from 'src/app/models/tItemModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { AppSettings } from 'src/app/shared/AppSettings';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { tBookAuxService } from 'src/app/services/tBookAux.service';
import { tBookAuxModel } from 'src/app/models/tBookAuxModel';
import { AppComponent } from 'src/app/app.component';

import { tWaitingConsultService } from 'src/app/services/tWaitingConsult.service';
import { isNullOrUndefined } from 'util';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';

@Component({
  selector: 'app-edit-waiting-consult-dialog',
  templateUrl: './edit-waiting-consult-dialog.component.html',
  styleUrls: ['./edit-waiting-consult-dialog.component.css']
})
export class EditWaitingConsultDialogComponent implements OnInit {

  editForm: FormGroup;
  private TAG = 'EditWaitingConsultDialogComponent';

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private patientDialogService: PatientDialogService,
    private searchEmployeeDialogService: SearchEmployeeDialogService,
    private dateTimeConvertService: DateTimeConvertService,
    private tPatientService: tPatientService,
    private newPatientDialogService: NewPatientDialogService,
    private tBookingService: tBookingService,
    private searchItemIDDialogService: SearchItemIDDialogService,
    private ren: Renderer2,
    private datepipe: DatePipe,
    private apiResultHandlerService: ApiResultHandlerService,
    private tBookAuxService: tBookAuxService,
    private tWaitingConsultService: tWaitingConsultService,
    private DateTimeConvertService: DateTimeConvertService,
  ) { }

  @Input() editModel: tConsultHeadModelWithPatientInfo;

  ngOnInit() {


    this.editForm = this.formBuilder.group({

      shopID: [],

      clthConsultNumber: [],
      clthArrivalDateTime: [],
      // clthPatientID: [],              // = bkPatientID

      patientChiName: [],
      patientSurname: [],
      patientPhone: [],

      // clthBookNumber: [],             // = bkBookingNumber (Optional)
      // clthPrescripNumber: [],         // Null
      // clthBillingNumber: [],          // Null
      // clthBedNumber: [],              // Null
      // clthDiagonsis: [],              // Null
      // clthDetailDesc: [],             // Null
      // clthFollowUpDesc: [],           // Null
      // clthRequestServiceName: [],     // = bkItemDescMobile1
      // clthRequestTherapistName: [],   // = bkTherapistName1
      clthRemark: [],                 // = bkBookRemark

      // clthFollowUp: [],
      // clthAuxName: [],                // = bkBookAuxName


      lastModifyDatetime: ['', ''],
      lastModifyUserID: [],
      // InActive: []

    });


    this.editForm.patchValue(this.editModel);

    const ArrTimeRaw = this.editForm.get('clthArrivalDateTime').value;
    this.editForm.get('clthArrivalDateTime').setValue(this.formatTime(ArrTimeRaw));
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  formatTime(time: string)
  {
    const newDate = new Date(time);
    return this.DateTimeConvertService.ConvertCurrentTime(newDate);
  }

  confirm () {
    this.log.i(this.TAG, 'onSubmit data = ' + JSON.stringify(this.editForm.value));


      this.tWaitingConsultService.updateRemark(this.editForm.value)
        .subscribe(data => {
          this.log.i(this.TAG, 'onSubmit success , data = ' + JSON.stringify(data));

          const returnData: any = data;

          // just close the dialog if success
          if (returnData.statusCode === StatusMessage.Status_OK) {
            this.activeModal.close(StatusMessage.Status_OK);
          }

          // show result dialog
          this.apiResultHandlerService.ResultHandler(
            data,
            '',
            AppSettings.Path_tConsultHead_OnConsult);

          // refresh

        },
          err => {
            this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
            this.apiResultHandlerService.ErrHandler();
          });
  }


}
